import styled from '@emotion/styled'
import { AnimatedLine } from 'app/components/Common/Animation/AnimatedLine'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import { styles } from 'app/theme'
import React, { memo } from 'react'
import { Accordion } from 'react-accessible-accordion'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  list: ItemProps[]
  description?: string
  title?: string
}

export const Directions = memo(function Directions({
  description,
  list,
  title,
}: Props) {
  if (!list) {
    return null
  }

  return (
    <Container>
      <AnimatedLine variant="dark" />
      <Wrapper>
        {title ? (
          <FadeInUp>
            <Title>{title}</Title>
          </FadeInUp>
        ) : null}

        {description ? (
          <FadeInUp>
            <Description dangerouslySetInnerHTML={{ __html: description }} />
          </FadeInUp>
        ) : null}

        <FadeInUp>
          <Accordion allowZeroExpanded>
            {list.map((item: any, index) => (
              <Item key={index} {...item} />
            ))}
          </Accordion>
        </FadeInUp>
      </Wrapper>
    </Container>
  )
})

const Container = styled.section`
  .accordion {
    .accordion-item-heading {
      /* border-radius: 1rem; */
      transition: 0.1s 0.3s ease-in-out;
    }

    > div {
      margin-bottom: 0.375rem;

      &.active {
        .accordion-item-heading {
          /* border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0; */
          transition: 0.1s ease-in-out;
        }

        svg {
          transform: rotate(90deg);
        }

        .item-title {
        }

        .item-inner {
          img {
            filter: none;
          }
        }
      }
    }
  }
`

const Wrapper = styled.div`
  padding: 3.75rem 13.472vw 7.5rem;

  @media (max-width: 1199px) {
    padding: 3rem 3rem 5.25rem;
  }
`

const Title = styled.h2`
  ${styles.title.normal}

  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  margin-bottom: 1.5rem;

  @media (max-width: 1199px) {
    margin-bottom: 0.75rem;
  }
`

const Description = styled.div`
  ${styles.description.dark}

  margin: 0 auto 3rem;
`
